<template>
  <ul class="keyword-chips">
    <li v-for="(keyword, index) in TOP_KEYWORD_CHIPS" :key="keyword">
      <Chip :href="searchUrl(keyword)" @click="onClickChip(keyword, index)">
        {{ keyword }}
      </Chip>
    </li>
  </ul>
</template>
<script setup>
import qs from 'qs'
import Chip from '../../atoms/chips/Chip.vue'
import { TOP_KEYWORD_CHIPS } from '../../../constants/keywordChipConstants'

const searchUrl = (keyword) => `/items?${qs.stringify({ keyword, via: 'top_keyword_chip' })}`

const onClickChip = (keyword, index) => {
  dataLayer.push({
    event: 'click_top__keyword_chip',
    keyword,
    rank: index + 1
  })
}
</script>
<style lang="scss" scoped>
.keyword-chips {
  display: flex;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  li {
    flex-shrink: 0;
  }
}
</style>
